import React from 'react'
import {Link} from 'react-router-dom'
import styles from './Mainpage.module.css'
import './Box.css';
import cx from 'classnames'


const Mainpage = () => {
    return(
    <div>
        <div className="row">
        <div className="navbar-fixed">
        <nav className="nav-wrapper white">
            <div className="container">
            <Link to='/' className="brand-logo" className={styles.logo}><img src='/img/image.tj9vk9'  alt='logo' /></Link>
                <ul className="right hide-on-med-and-down">
                <li><Link to ="/dashboard"className={cx('waves-effect', 'waves-light', 'brown', 'darken-1', 'btn', 'right',styles.but)}>Get Started</Link></li>
                <li><a href="https://github.com/durgesh30508" class="btn-floating  waves-effect waves-light black"><i class="fa fa-github" aria-hidden="true"></i></a></li>
                <li><a href="https://www.linkedin.com/in/durgesh-kumar-8a9612155/" class="btn-floating  waves-effect waves-light blue"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
                </ul>
            </div>
        </nav>
        </div>
        </div>
        <div className="container">
        <div className="row">
            <div className="col s6">
                <div className={styles.name}>
                <h1>VISUALISE ALGORITHMS</h1>
                <h6>Visualise Your Algorithms In A Better Way</h6>
                <br></br>
                <Link to="/dashboard" className="waves-effect brown darken-1 waves-light btn-large">Get Started</Link>
                </div>
                
            </div>
            <div className="col s6">
            <img src='/img/image.png'  alt='pic'/> 
            
            {/* <div id="wrapper">
                <div className="bbox-area">
                <div id="bbox-front" className="bbox-d">DIJKSTRAS</div>
                <div id="bbox-right" className="bbox-d">BINARY</div>
                <div id="bbox-back" className="bbox-d">MERGE</div>
                <div id="bbox-left" className="bbox-d">QUICK</div>
                <div id="bbox-top" className="bbox-d"></div>
                <div id="bbox-bottom" className="bbox-d"></div>
                </div>
            </div> */}
            </div>

        </div>
        </div>
    </div>
    )
}

export default Mainpage